import gql from "graphql-tag";

const recordActivityMutation = gql`
    mutation RecordActivityMutation($app: String, $activity: String, $activitySource: JSONString) {
        recordUserActivity(app: $app, activity: $activity, activitySource: $activitySource) {
            newActivity {
                created
            }
        }
    }
`;

export default recordActivityMutation;
